import { Breakpoint } from '@mui/system';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
    generalDialogAction,
    GeneralDialogContent,
    GeneralDialogState,
} from '../../redux/slices/generalDialogSlice';

const useConfirmDialog = () => {
    const state: GeneralDialogState = useAppSelector(
        (state) => state.generalDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = useCallback(
        (props: GeneralDialogContent, size?: Breakpoint) => {
            dispatch(generalDialogAction.setComponent(props));
            dispatch(generalDialogAction.setSize(size ? size : 'sm'));
            dispatch(generalDialogAction.setOpenDialog(true));
        },
        []
    );

    const closeDialog = () => {
        dispatch(generalDialogAction.setOpenDialog(false));
        dispatch(generalDialogAction.setSize(null));
    };

    return { ...state, showDialog, closeDialog };
};

export default useConfirmDialog;
